import Container from "@/components/Container/Container"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"
import {
  getDateWithMonthWithTime,
  getGMT,
  isPastEvent,
} from "@/utils/datehelpers.js"
import RegularButton from "@/components/RegularButton/RegularButton"
import styles from "./Intro.module.scss"

export default function Intro({ item }) {
  const link = `/events/${item.slug}/`

  if (isPastEvent(item.date_time)) {
    return null
  }

  return (
    <section className={styles.intro}>
      <Container>
        {item.slug}

        <Breadcrumbs
          home="Home"
          className={styles.intro__breadcrumbs}
          items={[{ name: "Events" }]}
        ></Breadcrumbs>

        <a className={styles.intro__image} href={link} target="_blank">
          {/* TODO: remake */}
          {item.banner_image_webp ? (
            <img src={item.banner_image_webp} alt={`${item.title} image`} />
          ) : item.banner_image ? (
            item.banner_image && (
              <img src={item.banner_image} alt={`${item.title} image`} />
            )
          ) : item.image_webp ? (
            <img src={item.image_webp} alt={`${item.title} image`} />
          ) : (
            item.image && <img src={item.image} alt={`${item.title} image`} />
          )}
          <div className={styles.intro__date}>
            {getDateWithMonthWithTime(item.date_time)}
            <span>{getGMT(item.time_zone)}</span>
          </div>
          <h1 dangerouslySetInnerHTML={{ __html: item.title }}></h1>

          {item.place && (
            <div className={styles.intro__location}>
              {item.type === "offline" ? (
                <div
                  dangerouslySetInnerHTML={{ __html: item.place.address }}
                ></div>
              ) : (
                <span>
                  live streamed from
                  <br />
                  {item.place && item.place.address}
                </span>
              )}
            </div>
          )}

          <RegularButton
            text="Sign up to event"
            justText={true}
          ></RegularButton>
        </a>
      </Container>
    </section>
  )
}
